/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { SeoLocationFAQ } from './model/seoLocationFAQ';

/**
 * Returns fact interpolated FAQs for a given SEO location.
 */
export const apiSearchSeoNeighborhoodFaqsList = (
  countryUrlPrefix: string,
  neighborhood: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  signal?: AbortSignal
) => {
  return HTTP<SeoLocationFAQ[]>({
    url: `/api/v7/seo-location/${countryUrlPrefix}/${neighborhood}--${city}--${regionSlug}--${seoSlug}/faqs/`,
    method: 'GET',
    signal,
  });
};

export const getApiSearchSeoNeighborhoodFaqsListQueryKey = (
  countryUrlPrefix?: string,
  neighborhood?: string,
  city?: string,
  regionSlug?: string,
  seoSlug?: string
) => {
  return [
    `/api/v7/seo-location/${countryUrlPrefix}/${neighborhood}--${city}--${regionSlug}--${seoSlug}/faqs/`,
  ] as const;
};

export const getApiSearchSeoNeighborhoodFaqsListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSearchSeoNeighborhoodFaqsList>>,
  TError = ErrorType<unknown>
>(
  countryUrlPrefix: string,
  neighborhood: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiSearchSeoNeighborhoodFaqsList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiSearchSeoNeighborhoodFaqsListQueryKey(
      countryUrlPrefix,
      neighborhood,
      city,
      regionSlug,
      seoSlug
    );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSearchSeoNeighborhoodFaqsList>>> = ({
    signal,
  }) =>
    apiSearchSeoNeighborhoodFaqsList(
      countryUrlPrefix,
      neighborhood,
      city,
      regionSlug,
      seoSlug,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(countryUrlPrefix && neighborhood && city && regionSlug && seoSlug),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiSearchSeoNeighborhoodFaqsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiSearchSeoNeighborhoodFaqsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSearchSeoNeighborhoodFaqsList>>
>;
export type ApiSearchSeoNeighborhoodFaqsListQueryError = ErrorType<unknown>;

export function useApiSearchSeoNeighborhoodFaqsList<
  TData = Awaited<ReturnType<typeof apiSearchSeoNeighborhoodFaqsList>>,
  TError = ErrorType<unknown>
>(
  countryUrlPrefix: string,
  neighborhood: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiSearchSeoNeighborhoodFaqsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiSearchSeoNeighborhoodFaqsListQueryOptions(
    countryUrlPrefix,
    neighborhood,
    city,
    regionSlug,
    seoSlug,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
